import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Constants } from '../../shared/pipes/constants';
import { LoginService } from 'mds-ui/app/shared/service/login.service';

@Component({
  moduleId: "module.id",
  selector: 'login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements AfterViewInit {
  isAuthorized: boolean;
  authorized: string = undefined;
  appName: string;
  constructor(private loginService: LoginService, private activateRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.appName = this.activateRoute.snapshot.queryParamMap.get('appName');
    this.authorized = this.activateRoute.snapshot.queryParamMap.get('auth');
    if (this.appName != sessionStorage.getItem("appName")) {
      if (this.authorized == Constants.IS_ACTIVE_YES ||
        this.authorized == undefined || this.authorized == null) {
        sessionStorage.setItem("appName", this.appName);
        if (this.appName != null) {
          window.location.href = this.loginService.getSignInEndpoint(this.appName);
          this.isAuthorized = false;
        } else {
          this.isAuthorized = true;
          this.authorized ='A';
        }
      } else {
        this.isAuthorized = true;
      }
    } else {
      if (this.authorized == Constants.IS_ACTIVE_YES ||
        this.authorized == undefined || this.authorized == null) {
        this.isAuthorized = false;
      } else {
        this.isAuthorized = true;
      }
    }
  }
  ngDoCheck() {
    this.appName = this.activateRoute.snapshot.queryParamMap.get('appName');
    this.authorized = this.activateRoute.snapshot.queryParamMap.get('auth');
    if (this.appName != sessionStorage.getItem("appName")) {
      sessionStorage.setItem("appName", this.appName);
      if (this.appName != null) {
        window.location.href = this.loginService.getSignInEndpoint(this.appName);
        this.isAuthorized = false;
      } else {
        this.isAuthorized = true;
        this.authorized ='A';
      }
    }
  }
  ngAfterViewInit() {

  }
  toNavigate($event: Event) {
    $event.preventDefault();
    window.location.href = this.loginService.getSignInEndpoint(this.appName);
  }
  toNavigate2($event: Event) {
    $event.preventDefault();
    this.authorized = undefined;
    this.isAuthorized = undefined;
    window.location.href = this.loginService.getLogOutEndpoint();
  }
}
